module.exports = __webpack_public_path__ + "img/aic.66b721be.jpg";